export default __webpack_public_path__ + "static/media/our-service-accounting-and-finance-background.18cb9307.jpg";